import BillingHTTP from 'utils/billing-http';
import Promise from 'bluebird';
import BaseService from './BaseService';

class CardPaymentService extends BaseService {
  charge(billingId, billId, cardId) {
    const data = {
      billing_id: parseInt(billingId, 10),
      bill_id: parseInt(billId, 10),
      card_id: parseInt(cardId, 10),
    };

    return new Promise((resolve) => {
      BillingHTTP.post('/dashboard-api/v2/payment-promises', data)
        .then((response) => {
          this.pollForPaymentUpdate(response.data, resolve);
        });
    });
  }

  pollForPaymentUpdate(paymentPromise, resolve) {
    setTimeout(() => BillingHTTP.get(`/dashboard-api/v2/payment-promises/${paymentPromise.id}`)
      .then((response) => {
        if (response.data.status !== 'pending') {
          resolve(response);
        } else {
          this.pollForPaymentUpdate(response.data, resolve);
        }
      }), 1000);
  }
}

export default new CardPaymentService();
